import {
  iconHolderSize,
  wheelControls,
  wheelSize,
  wheelTriggerR,
  wheelBackgroundBaseSize,
  wheelBackgroundBaseOpacity,
  wheelMaxSize,
} from '../constants'
import { map } from './utils'
import { blue } from '@material-ui/core/colors'
import p5 from 'p5'
import tinycolor from 'tinycolor2'

export const setupWheel = start => {
  const upHolder = document.querySelector('#icon-holder-up')
  const downHolder = document.querySelector('#icon-holder-down')
  const leftHolder = document.querySelector('#icon-holder-left')
  const rightHolder = document.querySelector('#icon-holder-right')
  const wheelBackground = document.querySelector('#tool-background')

  const unset = {
    left: 'unset',
    right: 'unset',
    top: 'unset',
    bottom: 'unset',
  }
  ;[upHolder, downHolder, leftHolder, rightHolder].forEach(h => {
    if (h) Object.assign(h.style, unset)
  })

  let cornerOffset = '3px'

  if (upHolder)
    Object.assign(upHolder.style, {
      left: `${(wheelSize - iconHolderSize) / 2}px`,
      top: cornerOffset,
      transform: 'scale(1)',
    })

  if (downHolder)
    Object.assign(downHolder.style, {
      left: `${(wheelSize - iconHolderSize) / 2}px`,
      bottom: cornerOffset,
      transform: 'scale(1)',
    })

  if (leftHolder)
    Object.assign(leftHolder.style, {
      left: cornerOffset,
      top: `${(wheelSize - iconHolderSize) / 2}px`,
      transform: 'scale(1)',
    })

  if (rightHolder)
    Object.assign(rightHolder.style, {
      right: cornerOffset,
      top: `${(wheelSize - iconHolderSize) / 2}px`,
      transform: 'scale(1)',
    })

  Object.assign(wheelBackground.style, {
    top: 0,
    left: 0,
    width: `${wheelBackgroundBaseSize}px`,
    height: `${wheelBackgroundBaseSize}px`,
    borderRadius: `${wheelBackgroundBaseSize / 2}px`,
    opacity: wheelBackgroundBaseOpacity,
    background: blue[600],
    transform: 'translate(0, 0)',
  })

  displayToolWheel(document.querySelector('#tool-wheel'), start)
}

export const feedForwardHolder = (holder, rawMag, angle, speed) => {
  const mag = Math.min(rawMag, wheelMaxSize)
  const magOffset = mag - wheelTriggerR

  /* ---------------------------------- Icons --------------------------------- */
  deHighlightHolders()
  let h = document.querySelector(holder)
  if (h) {
    h.style.transform =
      (angle !== null
        ? `translate(${magOffset * Math.cos(angle)}px, ${
            -magOffset * Math.sin(angle)
          }px) `
        : '') + `scale(1.2)`
  }

  /* ------------------------------- Background ------------------------------- */
  let b = document.querySelector('#tool-background')
  let hR = true

  if (holder === '#icon-holder-right') {
    Object.assign(b.style, {
      top: `${-magOffset / 2}px`,
      left: 0,
    })
    hR = true
  } else if (holder === '#icon-holder-left') {
    Object.assign(b.style, {
      top: `${-magOffset / 2}px`,
      left: `${-magOffset}px`,
    })
    hR = false
  }

  // const mainColor = tinycolor
  //   .mix(
  //     blue[600],
  //     purple[900],
  //     map(
  //       Math.abs(speed),
  //       wheelAdjustSpeedLow,
  //       wheelAdjustSpeedHigh,
  //       0,
  //       100,
  //       true
  //     )
  //   )
  //   .toRgbString()
  const mainColor = tinycolor(blue[700]).toRgbString()

  Object.assign(b.style, {
    width: `${wheelBackgroundBaseSize + magOffset}px`,
    height: `${wheelBackgroundBaseSize + magOffset}px`,
    borderRadius: `${(wheelBackgroundBaseSize + magOffset) / 2}px`,
    background: `linear-gradient(${hR ? '90deg' : '-90deg'}, ${tinycolor
      .mix(blue[600], '#fff', map(magOffset, 0, wheelMaxSize, 0, 100, true))
      .toRgbString()} 20%, ${tinycolor(
      blue[600]
    ).toRgbString()} 80%, ${mainColor} 90%)`,
  })
}

// Display
export const displayToolWheel = (wheel, start) => {
  Object.assign(wheel.style, {
    opacity: 1,
    transform: `translate(${start[0]}px, ${start[1]}px) rotate(90deg)`,
  })
}

// Hide
export const hideToolWheel = () => {
  deHighlightHolders()
  const wheel = document.querySelector('#tool-wheel')
  Object.assign(wheel.style, {
    opacity: 0,
    // transform: 'translate(0px, 0px)',
  })
}

export const deHighlightHolder = id => {
  let h = document.querySelector(id)
  if (h) {
    h.style.transform = `scale(1)`
    return h
  }
  return null
}

export const deHighlightHolders = () => {
  deHighlightHolder('#icon-holder-plus')
  deHighlightHolder('#icon-holder-minus')
  deHighlightHolder('#icon-holder-left')
  deHighlightHolder('#icon-holder-right')
}

/* --------------------------------- Vector --------------------------------- */

export const pointAt = vec => {
  // Return [zoomDirection, angle, rawAngle]
  const angle = (vec.angleBetween(new p5.Vector(1, 0)) * 180) / Math.PI

  /**
   *
   *      1
   *
   * 4         2
   *
   *      3
   *
   */

  // TODO Now lr is always true
  if (!wheelControls.tb) {
    // if ((angle >= 0 && angle < 90) || (angle < 0 && angle > -90))
    //   return [2, 0, angle]
    // else return [4, Math.PI, angle]
    if (angle > 0) return [4, Math.PI, angle]
    else return [2, 0, angle]
  } else {
    // tb us true
  }
}
